import {
  rAtLeastOneDigit,
  rAtLeastOneLowercase,
  rAtLeastOneSpecialCharacter,
  rAtLeastOneUppercase,
} from 'modules/common/lib/validation/rules'
import * as yup from 'yup'

export const validatePassword = yup
  .string()
  .required('')
  .test('minLength', (val) => !!val && val.length >= 7)
  .matches(rAtLeastOneDigit, {
    name: 'atLeastOneDigit',
  })
  .matches(rAtLeastOneUppercase, {
    name: 'atLeastOneUppercase',
  })
  .matches(rAtLeastOneLowercase, {
    name: 'atLeastOneLowercase',
  })
  .matches(rAtLeastOneSpecialCharacter, {
    name: 'atLeastOneSpecialCharacter',
  })
